import { isDefinedString } from "et3-type-guards";
import queryString from "query-string";
import { isNumber, memoize, orderBy } from "lodash";
import { computed, observable } from "mobx";

import getUserStore from "..";
import { apiCallGetUserLogin } from "../../../api/user-api/api-call-get-user-login";
import { TUserLoginData } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";

class UserLoginStore {
  userLoginData = observable.box<TUserLoginData[]>([]);
  userLoginDataOrdered = computed(() => {
    const ordereduserLoginData: TUserLoginData[] = orderBy(
      this.userLoginData.get(),
      ["created_on"],
      ["asc"]
    );
    return ordereduserLoginData;
  });

  checkURLSearch = async (search: string) => {
    if (isDefinedString(search)) {
      const searchID = queryString.parse(search).id;
      if (isDefinedString(searchID) && searchID !== "0") {
        const searchIDNumber = parseInt(searchID, 10);
        getUserStore().setUserIDInput(searchIDNumber);
        await getUserLoginStore().getUserLogin();
      }
    }
  };

  getUserLogin = async () => {
    const userId = getUserStore().userIdInput.get();
    if (!isNumber(userId) || userId === -1) {
      getCorePopUpStore().showAlertMessage("WRONG_USER_ID");
      return;
    }
    getCoreUIStore().setIsLoading("USER_LOGIN", true);
    const limit = reducerToZeroIfUndefined(
      parseInt(getUserStore().selectedLimitInput.get().value, 10)
    );
    const { data, code, status } = await apiCallGetUserLogin({
      userId,
      limit
    });

    this.userLoginData.set(data);
    getCoreUIStore().setIsLoading("USER_LOGIN", false);
    if (status === "ERROR") {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getUserLoginStore = memoize(
  () => new UserLoginStore(),
  () => 1
);
export default getUserLoginStore;
